import { Component, OnInit, Renderer2, Inject } from '@angular/core';
import { ModalController, NavController, LoadingController } from '@ionic/angular';
import { ProjectsService } from '../../services/projects.service'
import { Router } from '@angular/router';
import { AddAnnotationsModalPage } from '../../modals/add-annotations-modal/add-annotations-modal.page';
import { AuthorService } from '../../services/author.service';
import { PreviewService } from '../../services/preview.service';
import { AssetManagementService } from '../../services/asset-management.service';
import { Scene } from 'src/app/models/Scene';
import { AssetInScene } from 'src/app/models/AssetInScene';
import { AssetTypeService } from 'src/app/services/asset-type.service';
import { VrEventTypeService } from 'src/app/services/vr-event-type.service';
import { VrEventTriggerService } from 'src/app/services/vr-event-trigger.service';
import { QuestionRuleTypeService } from 'src/app/services/question-rule-type.service';
import { QuestionSetAsset } from 'src/app/models/assets/QuestionSetAsset';
import { QuestionResponse } from 'src/app/models/assets/QuestionResponse';
import { QuestionAsset } from 'src/app/models/assets/QuestionAsset';
import { QuestionRule } from 'src/app/models/question-rules/QuestionRule';
import { OutcomeActionService } from 'src/app/services/outcome-action.service';
import { OutcomeActionTypeService } from 'src/app/services/outcome-action-type.service';
import { TextToSpeechService } from 'src/app/services/text-to-speech.service';
import { MessagesService } from 'src/app/services/messages.service';

@Component({
  selector: 'app-viewer',
  templateUrl: './viewer.component.html',
  styleUrls: ['./viewer.component.scss'],
})

export class ViewerComponent implements OnInit {
  public projectID;
  public score;

  constructor(
    public projectService: ProjectsService,
    public router: Router,
    public modalController: ModalController,
    public renderer2: Renderer2,
    public navController: NavController,
    public authorService: AuthorService,
    public previewService: PreviewService,
    public loadingController: LoadingController,
    public assetManagementService: AssetManagementService,
    public assetTypeService: AssetTypeService,
    public VrEventTypeService: VrEventTypeService,
    public VrEventTriggerService: VrEventTriggerService,
    public questionRuleTypeService: QuestionRuleTypeService,
    public outcomeActionService: OutcomeActionService,
    public outcomeActionTypeService: OutcomeActionTypeService,
    public textToSpeechService: TextToSpeechService,
    public messagesService: MessagesService) { }

  async ngOnInit() {
    if (this.assetManagementService.assets == undefined || this.assetManagementService.assets.length == 0) {
      await this.assetManagementService.getAssetsOnManagementPage();
    }
    //this.previewService.setPreviewScenes();
    this.previewService.setScene(this.authorService.currentScene.sceneId);
    this.resetAssetsActionProperties();
    this.registerAFrameComponents();
    var qWeight = 0;

    this.previewService.assetsInScene.forEach((asset) => {
      if (this.getAssetType(asset) == 'Question')
        qWeight++;
    });

    if (qWeight == 0)
      this.score = 100;    
    
    setTimeout(() => {
      var sceneFullLoaded = document.querySelector('[preview-scene-full-loaded]');
      if(sceneFullLoaded.getAttribute('preview-scene-full-loaded') == '' || sceneFullLoaded.getAttribute('preview-scene-full-loaded') == 'false'){
        this.messagesService.presentAlert("An error occurred!", "An error occurred previewing the VR Scene, please try again.", "Close Preview")
        .then(() => {
          document.querySelector('#close-preview-modal-btn').click();
        });
      }
    }, 10000);
  }

  getTextAssetMaterial(assetInScene) {
    var result = 'visible: false;'

    if (assetInScene.baseAsset.hasBackground && assetInScene.baseAsset.text.length > 0) {
      result = 'visible: true;';
      result += 'color:' + assetInScene.baseAsset.backgroundColour + ';';
    }

    return result;
  }

  getTextAssetGeometry(assetInScene) {
    var text = assetInScene.baseAsset.text;
    var textLinesArray = text.split(/\r\n|\r|\n/);
    var textLines = textLinesArray.length;
    var linesBlankCount = 0;

    for (var i: number = 0; i < textLinesArray.length; i++) {
      var textLine: string = textLinesArray[i];
      var additionalTextLines = this.getAdditionalTextLines(textLine.trim());
      textLines = textLines + additionalTextLines - 1;
    }

    // totalWidth = data.value.length * (data.width / data.wrapCount)
    // the default width value for a-text is always 5
    // the wrap-count has been set as 20 
    // so here the width = text.length * (5 / 20) = text.length / 4
    // For more reference, please see https://aframe.io/docs/1.0.0/components/text.html#sizing
    var width = (text.length > 20 ? 5 : text.length / 4) + 0.2;
    //var height = Math.ceil(text.length / 20) / 2;
    var height = (textLines * 0.5) + 0.2;

    return 'primitive: plane; width: ' + width + '; height: ' + height;
  }

  getAdditionalTextLines(str): number{
    var lines = str.split(" ");
    var index = 0;
    var toContinue = false;
    while(!toContinue){
      var spacePos = lines[index].indexOf(" ");
      if(spacePos >= 0 || lines[index].length <= 21){
        if(!lines[index+1]) break;
        if(lines[index].length + lines[index+1].length <= 21){
          lines[index] = lines[index] + " " + lines[index + 1];
          lines.splice(index+1, 1);
        }else{
          index++;
        }
      }else{
        var newLine = lines[index].substring(21, 999);
        lines[index] = lines[index].substring(0, 21);
        lines.splice(index + 1, 0, newLine);
        index++;
      }
          
      if(index > lines.length) toContinue = true;
    }
    return lines.length;
  }

  resetAssetsActionProperties() {
    // This will reset the properties like submitted, questionIndex in QuestionSet Asset
    this.previewService.assetsInScene.forEach(assetInScene => {
      var assetType = this.getAssetType(assetInScene);
      if (assetType == 'QuestionSet') {
        var questionSet: QuestionSetAsset = assetInScene.baseAsset as QuestionSetAsset;
        questionSet.submitted = null;
        questionSet.questionIndex = questionSet.coverPage == true ? -1 : 0;
        if (assetInScene.sceneAssetRelation.textToSpeechUrl != null) {
          this.textToSpeechService.setQuestionSetTextToSpeechUrl(assetInScene);
        }

        assetInScene.assets.forEach(assetInAsset => {
          var questionAsset = assetInAsset.baseAsset as QuestionAsset;
          questionAsset.selectedResponseIndex = null;
          questionAsset.read = null;
          questionAsset.submitted = null;
        });
      } else if (assetType == 'Question') {
        var question = assetInScene.baseAsset as QuestionAsset;
        question.selectedResponseIndex = null;
        question.read = null;
        question.submitted = null;
      }
    });
    this.authorService.stopAllMedia();
  }

  checkIfParentHasGeometry(entityId) {
    if (document.querySelector('#preview-entity-' + entityId)) {
      return document.querySelector('#preview-entity-' + entityId).getAttribute('geometry') != null;
    }
    return false;
  }

  // async openAddAnnotation() {
  //   if (this.previewService.areAnnotationsEnabled) {
  //     const addAnnotationsModal = await this.modalController.create({
  //       component: AddAnnotationsModalPage,
  //       id: 'add-annotation-modal',
  //       componentProps: {
  //         "sceneIndex": this.previewService.sceneIndex,
  //         "scenes": this.previewService.scenes
  //       }
  //     });

  //     // addAnnotationsModal.onDidDismiss().then(result => {
  //     //   if (result.data != null) {
  //     //     if (result.data.isLinkedToAsset) {
  //     //       var linkedAsset = this.activeScenes[this.previewService.sceneIndex].vrobjects[result.data.linkedAsset];
  //     //     }
  //     //     var annotation = {
  //     //       "text": result.data.annotationText,
  //     //       "position": (result.data.isLinkedToAsset ? linkedAsset.posX + ' ' + (linkedAsset.posY - 0.5) + ' ' + linkedAsset.posZ : "0 0 -1.65"),
  //     //       "id": (this.activeScenes[this.previewService.sceneIndex].annotations.length),
  //     //     }

  //     //     this.activeScenes[this.previewService.sceneIndex].annotations.push(annotation);

  //     //     this.saveAnnotationToAuthorService();
  //     //   }
  //     // });
  //     return await addAnnotationsModal.present();
  //   }
  // }

  filter(data: any) {
    return data["active"] == true;
  }


  saveAnnotationToAuthorService() {
    var i = 0;
    var j = 0;

    this.authorService.scenes.forEach(element => {
      if (element.active == true) {
        // this.authorService.scenes[i].annotations = this.activeScenes[j].annotations;
        j++;
      }
      i++;
    });
    this.previewService.wereChangesMade = true;
  }

  updateAnnotationPosition(event) {
    var x = event.target.getAttribute('position').x;
    var y = event.target.getAttribute('position').y;
    var z = event.target.getAttribute('position').z;
    var id = event.target.getAttribute('annotationID');

    // this.authorService.scenes[this.activeScenes[this.previewService.sceneIndex].id].annotations[id].position = x + ' ' + y + ' ' + z;
    this.previewService.wereChangesMade = true;

    this.refreshActiveScenes();
  }

  refreshActiveScenes() {
    this.previewService.scenes = [];
    // this.previewService.sceneBackgrounds = [];
    // this.previewService.setPreviewScenes();
  }

  getCurrentScene(): Scene {
    return this.previewService.getCurrentScene();
  }


  registerAFrameComponents() {

    var previewService = this.previewService;
    var assetTypeService = this.assetTypeService;
    var VrEventTypeService = this.VrEventTypeService;
    var VrEventTriggerService = this.VrEventTriggerService;
    var questionRuleTypeService = this.questionRuleTypeService;
    var authorService = this.authorService;
    var outcomeActionTypeService = this.outcomeActionTypeService;
    var textToSpeechService = this.textToSpeechService;

    var sceneFullLoaded = 'preview-scene-full-loaded';
    if (!isAframeComponentRegistered(sceneFullLoaded)) {
      AFRAME.registerComponent(sceneFullLoaded, {
        init: function () {
          var sceneFullLoaded = document.querySelector('[preview-scene-full-loaded]');
          if(sceneFullLoaded){
            sceneFullLoaded.setAttribute('preview-scene-full-loaded', 'true');
          }
        }
      });
    }

    var previewSceneLoad = 'preview-scene-load';
    if (!isAframeComponentRegistered(previewSceneLoad)) {
      AFRAME.registerComponent(previewSceneLoad, {
        schema: {
          type: 'string'
        },
        update: function () {
          var entity = this.el;
          entity.addEventListener('loaded', function (evt) {
            var currentScene = getPreviewCurrentScene();
            if (currentScene.sceneBackgroundFileType == "Video") {
              var backgroundVideo: any = document.querySelector("#preview-pano-" + currentScene.sceneId);
              backgroundVideo.currentTime = 0;
              if (currentScene.autoplay === true) {
                backgroundVideo.play();
              }
            }
            moveCameraTo(0, Number(currentScene.yRot));
          });
        }
      });
    }

    var removePointerCursor = 'preview-remove-pointer-cursor';
    if (!isAframeComponentRegistered(removePointerCursor)) {
      AFRAME.registerComponent(removePointerCursor, {
        update: function () {
          var entity = this.el;
          entity.addEventListener('mouseenter', function (event) {
            var canvasArr = document.querySelectorAll('canvas');
            canvasArr.forEach((canvas: any) => {
              canvas.style.cursor = 'grab';
            });
          });

          entity.addEventListener('mouseup', function (event) {
            var canvasArr = document.querySelectorAll('canvas');
            setTimeout(() => {
              canvasArr.forEach((canvas: any) => {
                canvas.style.cursor = 'grab';
              });
            }, 100);
          });
        }
      });
    }

    var changeColourOnHover = 'preview-change-colour-on-hover';
    if (!isAframeComponentRegistered(changeColourOnHover)) {
      AFRAME.registerComponent(changeColourOnHover, {
        schema: {
          type: 'string'
        },
        update: function () {
          var entity = this.el;
          var prevColour = this.data;
          entity.addEventListener('mouseenter', function (evt) {
            entity.setAttribute('color', '#e74c3c');
          });
          entity.addEventListener('mouseleave', function (evt) {
            entity.setAttribute('color', prevColour);
          });
        }
      });
    }

    var setResponsePosition = 'preview-set-response-position';
    if (!isAframeComponentRegistered(setResponsePosition)) {
      AFRAME.registerComponent(setResponsePosition, {
        schema: {
          responseOrder: { type: 'string' },
        },
        init: function () {
          let entity = this.el;
          let responseOrder = entity.getAttribute('response-id');

          let spacingDifference = responseOrder * 0.38;
          let startingPosition = 0.65;
          spacingDifference = startingPosition - spacingDifference;
          entity.setAttribute('position', '0 ' + spacingDifference + ' 0');
        },
      });
    }

    var setQuizResponsePosition = 'preview-set-quiz-response-position';
    if (!isAframeComponentRegistered(setQuizResponsePosition)) {
      AFRAME.registerComponent(setQuizResponsePosition, {
        schema: {
          responseOrder: { type: 'string' },
        },
        init: function () {
          let entity = this.el;
          let responseOrder = entity.getAttribute('response-id');

          let spacingDifference = responseOrder * 0.38;
          let startingPosition = 0.85;
          spacingDifference = startingPosition - spacingDifference;
          entity.setAttribute('position', '0 ' + spacingDifference + ' 0');
        },
      });
    }
    
    var setResponseCheckboxColour = 'preview-set-response-checkbox-colour';
    if (!isAframeComponentRegistered(setResponseCheckboxColour)) {
      AFRAME.registerComponent(setResponseCheckboxColour, {
        update: function () {
          let entity = this.el;
          let entityId = entity.getAttribute('preview-entity-id');
          let colour = getResponseCheckboxColour(entityId);

          entity.setAttribute('color', colour);
          if(colour.toLowerCase() == '#ffffff'){
            entity.querySelector('[check-mark]').setAttribute('src', '#asset-check-mark-white-icon');
          }else{
            entity.querySelector('[check-mark]').setAttribute('src', '#asset-check-mark-icon');
          }
        }
      });
    }

    var previewSelectResponse = 'preview-select-response';
    if (!isAframeComponentRegistered(previewSelectResponse)) {
      AFRAME.registerComponent(previewSelectResponse, {
        update: function () {
          var entity = this.el;

          this.ResponseEventHandler = function (evt) {
            var entityId = entity.getAttribute('preview-entity-id');
            var responseId = entity.getAttribute('preview-response-id');
            var submitButton = document.querySelector('#preview-submit-button-' + entityId);
            var assetInScene = getAssetWithSceneAssetRelationId(entityId);
            var questionAsset = assetInScene.baseAsset as QuestionAsset;

            if (questionAsset.submitted == true || entity.classList.contains('selected')) {
              return;
            }

            clearSelectedResponses(entityId);

            entity.setAttribute('animation', {
              property: 'scale',
              to: '1.1 1.1 0.5',
              easing: 'easeInOutBack',
              dur: '1000'
            });

            questionAsset.selectedResponseIndex = responseId;
            entity.classList.add('class', 'selected');
            entity.querySelector('[check-mark]').setAttribute('scale', '0.9 0.9 0.1');

            for (let i = 0; i < assetInScene.questionRules.length; i++) {
              if (checkIsToTriggerRule(assetInScene.questionRules[i], entityId, +responseId, true)) {
                triggerRule(assetInScene.questionRules[i]);
              }
            }

            submitButton.classList.add('clickable');
          }
          entity.addEventListener('click', this.ResponseEventHandler);
        },
        remove: function () {
          var entity = this.el;
          entity.removeEventListener('click', this.ResponseEventHandler);
        }
      });
    }

    var previewSelectResponseCircle = 'preview-select-response-circle';
    if (!isAframeComponentRegistered(previewSelectResponseCircle)) {
      AFRAME.registerComponent(previewSelectResponseCircle, {
        update: function () {
          var entity = this.el;

          this.ResponseEventHandler = function (evt) {
            var parentEntity = entity.parentElement;

            parentEntity.click();
          }

          entity.addEventListener('click', this.ResponseEventHandler);
        },
        remove: function () {
          var entity = this.el;
          entity.removeEventListener('click', this.ResponseEventHandler);
        }
      });
    }

    var previewAppendTextToSpeechSrc = 'preview-append-text-to-speech-src';
    if (!isAframeComponentRegistered(previewAppendTextToSpeechSrc)) {
      AFRAME.registerComponent(previewAppendTextToSpeechSrc, {
        schema: {
          ID: { type: 'string' },
        },
        update: function () {
          var entity = this.el;
          var ID = '#preview-text-to-speech-' + this.data;
          entity.setAttribute('src', ID);

        },
      });
    }

    var setTextToSpeechPosition = 'preview-set-text-to-speak-position';
    if (!isAframeComponentRegistered(setTextToSpeechPosition)) {
      AFRAME.registerComponent(setTextToSpeechPosition, {
        init: function () {
          var soundEntity = this.el;
          var textGeometryEntity = soundEntity.parentElement.querySelector('[text-geometry]');

          var geo = textGeometryEntity.getAttribute('geometry');
          if (geo) {
            var position = '0 ' + ((geo.height / 2) + 0.3) + ' 0.2';
            soundEntity.setAttribute('position', position);
            //soundEntity.setAttribute('position', '0 0.3 0.2');
          }
        }
      });
    }

    var previewSetTextToSpeakPositionQuestion = 'preview-set-text-to-speak-position-question';
    if (!isAframeComponentRegistered(previewSetTextToSpeakPositionQuestion)) {
      AFRAME.registerComponent(previewSetTextToSpeakPositionQuestion, {
        init: function () {
          var soundEntity = this.el;
          var textEntity = soundEntity.parentElement;
          var geo = textEntity.getAttribute('geometry');
          if (geo) {
            soundEntity.setAttribute('position', '0 ' + (0.1 + (geo.height / 2)) + ' 0');
          }
        }
      });
    }

    var previewTextToSpeech = 'preview-text-to-speech';
    if (!isAframeComponentRegistered(previewTextToSpeech)) {
      AFRAME.registerComponent(previewTextToSpeech, {
        init: function () {
          var entity = this.el;
          this.el.addEventListener('click', function (event) {
            if (isEntityVisible(entity)) {
              var entityId = entity.getAttribute('preview-entity-id');
              var assetInScene = getAssetWithSceneAssetRelationId(entityId);
              var assetType = getAssetType(assetInScene);
              var entitySrc = entity.getAttribute('src');
              var src = document.querySelector(entitySrc);
              if (src) {
                if (assetType == 'Question') {
                  playQuestionAssetTextToSpeech(src, assetInScene);
                }
                if (assetType == 'QuestionSet') {
                  playQuestionSetTextToSpeech(src, assetInScene);
                } else {
                  src.play();
                }
              }
            }
          });
        }
      });
    }

    function playQuestionAssetTextToSpeech(src: any, assetInScene: AssetInScene) {
      var questionAsset = assetInScene.baseAsset as QuestionAsset;
      var endedEventHandler = function (event) {
        var questionMessageSrc = '#' + src.id;
        if (questionAsset.selectedResponseIndex == questionAsset.responses.findIndex(r => r.isCorrect == true))
          questionMessageSrc += "-correct-message";
        else
          questionMessageSrc += "-incorrect-message";

        var questionMessageAudio = document.querySelector(questionMessageSrc);
        if (questionMessageAudio) questionMessageAudio.play();

      }
      if (questionAsset.submitted == true) {
        src.removeEventListener('ended', endedEventHandler);
        src.addEventListener('ended', endedEventHandler);
      }
      src.play();
    }

    function playQuestionSetTextToSpeech(src: any, assetInScene: AssetInScene) {
      var questionSetAsset = assetInScene.baseAsset as QuestionSetAsset;

      if (questionSetAsset.questionIndex == -1) {
        src.play();
      } else {
        if (!questionSetAsset.submitted) {
          playConfirmationPageTextToSpeech(assetInScene);
        } else {
          playResultsPageTextToSpeech(assetInScene);
        }
      }
    }

    function playConfirmationPageTextToSpeech(assetInScene) {
      var confirmationPageTextAudio = document.querySelector('#preview-question-set-confirmation-page-' + assetInScene.sceneAssetRelation.sceneAssetRelationId);
      var questionSet: QuestionSetAsset = assetInScene.baseAsset as QuestionSetAsset;
      var textToSpeech: string = questionSet.confirmationPageTitle + ". ";
      var confirmationText: string = questionSet.confirmationPageAnswersCompletedText;

      assetInScene.assets.forEach(assetInAsset => {
        var questionAsset: QuestionAsset = assetInAsset.baseAsset as QuestionAsset;
        if (!questionAsset.selectedResponseIndex) {
          confirmationText = questionSet.confirmationPageAnswersNotCompletedText;
        }
      });

      textToSpeech = textToSpeech + confirmationText + ".";
      var loadedDataEventHandler = function (event) {
        event.target.play();
      }
      confirmationPageTextAudio.removeEventListener("loadeddata", loadedDataEventHandler);
      confirmationPageTextAudio.addEventListener("loadeddata", loadedDataEventHandler);
      confirmationPageTextAudio.setAttribute('src', textToSpeechService.getTextToSpeechSrc(textToSpeech));
    }

    function playResultsPageTextToSpeech(assetInScene) {
      var resultsPageTextAudio = document.querySelector('#preview-question-set-results-page-' + assetInScene.sceneAssetRelation.sceneAssetRelationId);
      var questionSet: QuestionSetAsset = assetInScene.baseAsset as QuestionSetAsset;
      var textToSpeech: string = questionSet.resultsPageTitle + ". " + questionSet.resultsPageText + ". ";
      var correctQuestions = assetInScene.assets.filter(assetInAsset => {
        var question: QuestionAsset = assetInAsset.baseAsset as QuestionAsset;
        return question.selectedResponseIndex == question.responses.findIndex(r => r.isCorrect);
      });
      var score = correctQuestions.reduce((prev, cur) => {
        var question: QuestionAsset = cur.baseAsset as QuestionAsset;
        return prev + question.score
      }, 0);
      var maxScore = assetInScene.assets.reduce((prev, cur) => {
        var question: QuestionAsset = cur.baseAsset as QuestionAsset;
        return prev + question.score
      }, 0);
      var textToSpeechScore = `Your Score: ${score} of ${maxScore}. `;
      var resultsPagePassFailText = authorService.getQuestionSetPassedFailText(assetInScene) + ".";

      textToSpeech = textToSpeech + textToSpeechScore + resultsPagePassFailText;

      var loadedDataEventHandler = function (event) {
        event.target.play();
      }
      resultsPageTextAudio.removeEventListener("loadeddata", loadedDataEventHandler);
      resultsPageTextAudio.addEventListener("loadeddata", loadedDataEventHandler);
      resultsPageTextAudio.setAttribute('src', textToSpeechService.getTextToSpeechSrc(textToSpeech));
    }

    var previewAppendSrc = 'preview-append-src';
    if (!isAframeComponentRegistered(previewAppendSrc)) {
      AFRAME.registerComponent(previewAppendSrc, {
        schema: {
          ID: { type: 'string' },
        },

        update: function () {
          var entity = this.el;
          var ID = '#preview-asset-' + this.data;
          entity.setAttribute('src', ID);
        },
      });
    }

    var previewInitVideoEvent = 'preview-init-video-events';
    if (!isAframeComponentRegistered(previewInitVideoEvent)) {
      AFRAME.registerComponent(previewInitVideoEvent, {
        update: function () {
          var scene = getPreviewCurrentScene();
          if (scene && scene.events) {
            if (scene.events && scene.events.length > 0) {  // iterating through the asset events and initiating each of them.
              for (var eventIndex = 0; eventIndex < scene.events.length; eventIndex++) {
                previewSetUpSceneEvent(scene, eventIndex);
              }
            }
          }
        },
      });
    }

    var PreviewSceneEvent = 'preview-scene-event';
    if (!isAframeComponentRegistered(PreviewSceneEvent)) {
      AFRAME.registerComponent(PreviewSceneEvent, {
        schema: {
          sceneId: { type: 'string' },
          linkedAssetId: { type: 'string' },
          eventTypeId: { type: 'string' },
          timeOfEvent: { type: 'string' }
        },
        multiple: true, // allows having multiple versions of the same component attached to the same entity.
        init: function () {
          var video = document.querySelector('#preview-pano-' + this.data.sceneId) as any;
          this.video = video as HTMLVideoElement;
          this.timeOfEvent = this.data.timeOfEvent;
          this.eventType = getVrEventType(this.data.eventTypeId);
          var usesEntityOverAsset = checkIsMediaEvent(this.eventType) ? false : true;

          this.eventHandlerDto = {
            'linkedEntity': (usesEntityOverAsset == true ? document.querySelector('#preview-entity-' + this.data.linkedAssetId) : document.querySelector('#preview-asset-' + this.data.linkedAssetId)),
            'linkedSceneId': this.data.linkedAssetId
          }

        },
        // Tick is used because timeupdate event isn't accurate enough - timeupdate runs on it's own thread but isn't given priority so if timeOfEvent is '5', the timeupdate may set the currentTime to 4 then 6.
        tick: function () {
          if (this.video && this.video.currentTime >= (this.timeOfEvent - 0.05) && this.video.currentTime <= (this.timeOfEvent + 0.05)) {
            triggerEvent(this.eventType, this.eventHandlerDto);
          }
        }
      });
    }


    function previewSetUpSceneEvent(scene, eventIndex) {
      var videoSphere = document.querySelector('#preview-sky');

      videoSphere.setAttribute('preview-scene-event__' + eventIndex,
        {
          'sceneId': scene.sceneId,
          'linkedAssetId': scene.events[eventIndex].linkedContentId,
          'eventTypeId': scene.events[eventIndex].eventTypeId,
          'timeOfEvent': scene.events[eventIndex].timeOfEvent,
        });
    }

    var initEvent = 'preview-init-event';
    if (!isAframeComponentRegistered(initEvent)) {
      AFRAME.registerComponent(initEvent, {
        schema: {
          index: { type: 'string' },
        },
        init: function () {
          let asset = getAssetWithSceneAssetRelationId(this.data);
          if (asset && asset.events) {
            if (asset.events && asset.events.length > 0) {
              let assetEvents = asset.events;
              for (var eventIndex = 0; eventIndex < asset.events.length; eventIndex++) {
                if (assetEvents[eventIndex].linkedContentId == asset.sceneAssetRelation.sceneAssetRelationId) {
                  let eventToLastPosition = assetEvents.splice(eventIndex, 1)[0];
                  assetEvents.push(eventToLastPosition);
                }
              }

              console.log(assetEvents);
              for (var eventIndex = 0; eventIndex < assetEvents.length; eventIndex++) {
                var entity = getEntityForEventListener(asset.sceneAssetRelation.sceneAssetRelationId);
                setUpAssetEvent(asset.sceneAssetRelation.sceneAssetRelationId, assetEvents[eventIndex], eventIndex, entity);
              }
            }
          }
        },
      });
    }

    var initRule = 'preview-init-rule';
    if (!isAframeComponentRegistered(initRule)) {
      AFRAME.registerComponent(initRule, {
        schema: {
          index: { type: 'string' },
        },
        init: function () {
          var sceneAssetRelationId = +this.data;

          this.RuleEventHandler = function (event) {
            if (isEntityVisible(event.target) == true) {
              var disabled = event.target.getAttribute('disabled');
              if (disabled) {
                return;
              }

              var parentAssetInScene = getParentAssetInScene(sceneAssetRelationId);
              var baseEntity = document.querySelector('#preview-entity-' + parentAssetInScene.sceneAssetRelation.sceneAssetRelationId);
              var asset = getAssetWithSceneAssetRelationId(sceneAssetRelationId);
              var questionAsset = asset.baseAsset as QuestionAsset;
              var responseId = questionAsset.selectedResponseIndex;
              var triggeredRules = 0;

              if (asset && asset.questionRules) {
                if (isEntityVisible(baseEntity)) {
                  addDelayToQuizNextPreviousButtons(baseEntity);

                  questionAsset.read = true;
                  if (getAssetType(parentAssetInScene) == 'QuestionSet') {
                    var questionSet = parentAssetInScene.baseAsset as QuestionSetAsset;
                    if (responseId) {
                      //GO TO NEXT QUESTION
                      if (questionSet.confirmationPage == false && questionAsset.submitted == true){
                        showQuestionInQuestionSet(parentAssetInScene.sceneAssetRelation.sceneAssetRelationId, questionSet.questionIndex + 1);
                        return;
                      }
                      // SUBMIT QUESTION IN TIME IF QUESTION SET HAS NO CONFIRMATION PAGE
                      if (questionSet.confirmationPage == false) {
                        questionAsset.submitted = true;
                        
                        var questionIndexButtons = baseEntity.querySelectorAll('[preview-set-question-index-position]');

                        questionIndexButtons.forEach(questionIndexButton => {
                          questionIndexButton.removeAttribute('preview-set-question-index-position');
                        });
          
                        setTimeout(() => {
                          questionIndexButtons.forEach(questionIndexButton => {
                            questionIndexButton.setAttribute('preview-set-question-index-position', '');
                          });
                        }, 200);
                      }
                      // TRIGGER THE RULES
                      for (let i = 0; i < asset.questionRules.length; i++) {
                        if (checkIsToTriggerRule(asset.questionRules[i], sceneAssetRelationId, +responseId)) {
                          triggeredRules = triggeredRules + 1;
                          triggerRule(asset.questionRules[i]);
                        }
                      }
                      // SUBMIT QUESTION SET IN TIME IF ALL QUESTIONS ARE SUBMITTED AND QUESTION SET HAS NO CONFIRMATION PAGE
                      if (questionSet.confirmationPage == false && getAllQuestionsSubmittedInAsset(parentAssetInScene).length == parentAssetInScene.assets.length) {
                        questionSet.submitted = true;
                        //Trigger QuestionSet Events
                        for (var eventIndex = 0; eventIndex < parentAssetInScene.events.length; eventIndex++) {
                          var trigger = getVrEventTrigger(parentAssetInScene.events[eventIndex].eventTriggerId);
                          var eventType = getVrEventType(parentAssetInScene.events[eventIndex].eventTypeId);
                          var entityOrAsset = document.querySelector('#preview-entity-' + parentAssetInScene.sceneAssetRelation.sceneAssetRelationId);
                          var eventHandlerDto = getEntityEventHandlerDto(entityOrAsset, parentAssetInScene.events[eventIndex].linkedContentId,
                            trigger, true, parentAssetInScene.sceneAssetRelation.sceneAssetRelationId);
                          if (shouldQuestionSetEventTrigger(parentAssetInScene, trigger)) triggerEvent(eventType, eventHandlerDto);
                        }

                        if (questionSet.resultsPage == true) {
                          //showQuestionInQuestionSet(parentAssetInScene.sceneAssetRelation.sceneAssetRelationId, parentAssetInScene.assets.length);
                          var questionIndexButtons = baseEntity.querySelectorAll('[preview-set-question-index-position]');

                          questionIndexButtons.forEach(questionIndexButton => {
                            questionIndexButton.removeAttribute('preview-set-question-index-position');
                          });
            
                          setTimeout(() => {
                            questionIndexButtons.forEach(questionIndexButton => {
                              questionIndexButton.setAttribute('preview-set-question-index-position', '');
                            });
                          }, 200);
                          return;
                        }
                      }

                      if (triggeredRules == 0 && questionSet.confirmationPage == true && (questionSet.questionIndex != parentAssetInScene.assets.length - 1
                        || (questionSet.questionIndex == parentAssetInScene.assets.length - 1))) {
                        showQuestionInQuestionSet(parentAssetInScene.sceneAssetRelation.sceneAssetRelationId, questionSet.questionIndex + 1);
                      }
                    } else {
                      if (questionSet.confirmationPage == true && questionSet.questionIndex < parentAssetInScene.assets.length) { //FOR NEXT BUTTON
                        showQuestionInQuestionSet(parentAssetInScene.sceneAssetRelation.sceneAssetRelationId, questionSet.questionIndex + 1);
                      }
                    }
                  } else {
                    // SET NORMAL QUESTION SUBMITTED
                    questionAsset.submitted = true;
                    // TRIGGER THE RULES
                    for (let i = 0; i < asset.questionRules.length; i++) {
                      if (checkIsToTriggerRule(asset.questionRules[i], sceneAssetRelationId, +responseId)) {
                        triggeredRules = triggeredRules + 1;
                        triggerRule(asset.questionRules[i]);
                      }
                    }
                  }
                }
              }
            }
          }

          this.el.addEventListener('click', this.RuleEventHandler);
        },
        remove: function () {
          this.el.removeEventListener('click', this.RuleEventHandler);
        }
      });
    }

    function addDelayToQuizNextPreviousButtons(quizEntity) {
      var nextButtons = quizEntity.querySelectorAll('[preview-init-rule');
      nextButtons.forEach(button => {
        button.setAttribute('disabled', 'true');
      });

      setTimeout(() => {
        nextButtons.forEach(button => {
          button.removeAttribute('disabled');
        });
      }, 1500);
    }

    var initOutcomeAction = 'preview-init-outcome-action';
    if (!isAframeComponentRegistered(initOutcomeAction)) {
      AFRAME.registerComponent(initOutcomeAction, {
        schema: {
          index: { type: 'string' },
        },
        init: function () {
          var asset = getAssetWithSceneAssetRelationId(this.data);
          if (asset && asset.outcomeActions) {
            for (var outcomeActionIndex = 0; outcomeActionIndex < asset.outcomeActions.length; outcomeActionIndex++) {
              var entity = getEntityForEventListener(asset.sceneAssetRelation.sceneAssetRelationId);
              setUpAssetOutcomeAction(asset, outcomeActionIndex, entity);
            }
          }
        },
      });
    }

    var inVrEvent = 'preview-asset-event';
    if (!isAframeComponentRegistered(inVrEvent)) {
      AFRAME.registerComponent(inVrEvent, {
        schema: {
          sceneAssetRelationId: { type: 'string' },
          linkedAssetId: { type: 'string' },
          triggerId: { type: 'string' },
          eventTypeId: { type: 'string' },
          usesEntityOverAsset: { type: 'string' },
        },
        multiple: true, // allows having multiple versions of the same component attached to the same entity.
        init: function () {

          this.trigger = getVrEventTrigger(this.data.triggerId); // the trigger type 'play', 'click', etc.
          var event = getVrEventType(this.data.eventTypeId);
          var eventHandlerDto = getEntityEventHandlerDto(this.el, this.data.linkedAssetId, this.trigger, this.data.usesEntityOverAsset, this.data.sceneAssetRelationId);

          if (doesVideoTriggerBackgroundVideo(event)) {
            var videoSrc = document.querySelector('#preview-sky').getAttribute('src');
            eventHandlerDto.linkedEntity = document.querySelector(videoSrc);
          }

          if (event == 'Link Scene') {
            eventHandlerDto.linkedSceneId = this.data.linkedAssetId;
          }

          this.vrObjectEventHandler = function (evt) {
            if (isEntityVisible(eventHandlerDto.baseEntity)) {
              // if question exists, then it is a question asset, else trigger as normal.
              if (eventHandlerDto.question) {
                var selectedResponse = eventHandlerDto.question.querySelector('.selected');
                if (selectedResponse) {
                  if (shouldQuestionEventTrigger(selectedResponse, eventHandlerDto.passOrFail)) {
                    triggerEvent(event, eventHandlerDto);
                  }
                }
              } else if (eventHandlerDto.questionSet) {
                var sceneAssetRelationId = evt.target.getAttribute('preview-entity-id');
                var assetInScene = getAssetWithSceneAssetRelationId(sceneAssetRelationId);
                if (shouldQuestionSetEventTrigger(assetInScene, eventHandlerDto.passOrFail)) {
                  triggerEvent(event, eventHandlerDto);
                }
              } else {
                var sceneAssetRelationId = evt.target.getAttribute('preview-entity-id');
                var assetInScene = getAssetWithSceneAssetRelationId(sceneAssetRelationId);
                if (assetInScene) {
                  var assetType = getAssetType(assetInScene);
                  if (assetType == 'Question') {
                    var questionEntity = document.querySelector('#preview-entity-' + sceneAssetRelationId);
                    var selectedQuestionResponse = questionEntity.querySelector('.selected');
                    if (selectedQuestionResponse) triggerEvent(event, eventHandlerDto);
                  } else {
                    triggerEvent(event, eventHandlerDto);
                  }
                } else {
                  triggerEvent(event, eventHandlerDto);
                }
              }
            }
          }

          // if is a question asset, this.trigger would = 'pass' or 'fail' and must be set back to 'click', else just set it back to this.trigger
          this.trigger = (eventHandlerDto.question != null || eventHandlerDto.questionSet != null) ? 'click' : this.trigger;

          eventHandlerDto.entityOrAsset.addEventListener(this.trigger, this.vrObjectEventHandler);
        },

        remove: function () {
          // when component is removed, event listener must also be removed
          var entity = this.el;
          entity.removeEventListener(this.trigger, this.vrObjectEventHandler);
        }
      });
    }

    var outcomeAction = 'preview-asset-outcome-action';
    if (!isAframeComponentRegistered(outcomeAction)) {
      AFRAME.registerComponent(outcomeAction, {
        schema: {
          sceneAssetRelationId: { type: 'string' },
          outcomeId: { type: 'string' },
          outcomeActionTypeId: { type: 'string' },
          usesEntityOverAsset: { type: 'string' },
        },
        multiple: true, // allows having multiple versions of the same component attached to the same entity.
        update: function () {
          var outcomeId = this.data.outcomeId;
          var outcomeActionType = getOutcomeActionType(this.data.outcomeActionTypeId);
          var outcomeActionHandlerDto = getEntityOutcomeActionHandlerDto(this.el, outcomeActionType, this.data.usesEntityOverAsset, this.data.sceneAssetRelationId);

          this.AssetOutcomeActionHandler = function (evt) {
            if (isEntityVisible(outcomeActionHandlerDto.baseEntity)) {
              // if question exists, then it is a question asset, else trigger as normal.
              if (outcomeActionHandlerDto.question) {
                var selectedResponse = outcomeActionHandlerDto.question.querySelector('.selected');
                if (selectedResponse) {
                  if (shouldQuestionEventTrigger(selectedResponse, outcomeActionHandlerDto.passOrFail)) {
                    achieveOutcome(outcomeId);
                  }
                }
              } else if (outcomeActionHandlerDto.questionSet) {
                var sceneAssetRelationId = evt.target.getAttribute('preview-entity-id');
                var assetInScene = getAssetWithSceneAssetRelationId(sceneAssetRelationId);
                if (shouldQuestionSetEventTrigger(assetInScene, outcomeActionHandlerDto.passOrFail)) {
                  achieveOutcome(outcomeId);
                }
              } else {
                achieveOutcome(outcomeId);
              }
            }
          }

          // if is a question asset, this.trigger would = 'pass' or 'fail' and must be set back to 'click', else just set it back to this.trigger
          this.trigger = getOutcomeActionTrigger(outcomeActionType);

          outcomeActionHandlerDto.entityOrAsset.addEventListener(this.trigger, this.AssetOutcomeActionHandler);
        },

        remove: function () {
          // when component is removed, event listener must also be removed
          var entity = this.el;
          entity.removeEventListener(this.trigger, this.AssetOutcomeActionHandler);
        }
      });
    }

    var questionSetSubmit = 'preview-init-question-set-submit';
    if (!isAframeComponentRegistered(questionSetSubmit)) {
      AFRAME.registerComponent(questionSetSubmit, {
        schema: {
          type: 'string'
        },
        update: function () {
          var entity = this.el;

          entity.addEventListener('click', function (event) {
            if (isEntityVisible(entity)) {
              var sceneAssetRelationId = event.target.getAttribute('preview-entity-id');
              var asset = getAssetWithSceneAssetRelationId(sceneAssetRelationId);
              var questionSetAsset = asset.baseAsset as QuestionSetAsset;
              var baseEntity = document.querySelector('#preview-entity-' + sceneAssetRelationId);
              var questionIndexButtons = baseEntity.querySelectorAll('[preview-set-question-index-position]');
              asset.assets.forEach(a => {
                var question = a.baseAsset as QuestionAsset;
                question.submitted = true;
              });

              questionSetAsset.submitted = true;
              if (questionSetAsset.resultsPage == false) {
                showQuestionInQuestionSet(sceneAssetRelationId, 0);
              }

              questionIndexButtons.forEach(questionIndexButton => {
                questionIndexButton.removeAttribute('preview-set-question-index-position');
              });

              setTimeout(() => {
                questionIndexButtons.forEach(questionIndexButton => {
                  questionIndexButton.setAttribute('preview-set-question-index-position', '');
                });
              }, 200);

            }
          });
        }
      })
    }

    var questionSetStart = 'preview-init-question-set-start';
    if (!isAframeComponentRegistered(questionSetStart)) {
      AFRAME.registerComponent(questionSetStart, {
        schema: {
          type: 'string'
        },
        update: function () {
          var entity = this.el;
          var sceneAssetRelationId = entity.getAttribute('preview-entity-id');
          var asset = getAssetWithSceneAssetRelationId(sceneAssetRelationId);
          var questionSetAsset = asset.baseAsset as QuestionSetAsset;

          entity.addEventListener('click', function (event) {
            if (isEntityVisible(entity)) {
              var questionIndex = 0;

              questionSetAsset.submitted = null;

              asset.assets.forEach(assetInAsset => {
                clearSelectedResponses(assetInAsset.sceneAssetRelation.sceneAssetRelationId);
              });

              showQuestionInQuestionSet(sceneAssetRelationId, questionIndex);
            }
          });
        }
      })
    }

    var questionIndexAction = 'preview-init-question-index-action';
    if (!isAframeComponentRegistered(questionIndexAction)) {
      AFRAME.registerComponent(questionIndexAction, {
        schema: {
          type: 'string'
        },
        init: function () {
          var entity = this.el;
          var sceneAssetRelationId = entity.getAttribute('preview-entity-id');
          var asset = getAssetWithSceneAssetRelationId(sceneAssetRelationId);
          var questionSetAsset = asset.baseAsset as QuestionSetAsset;

          entity.addEventListener('click', function (event) {
            if (isEntityVisible(entity)) {
              var questionIndex = +event.target.getAttribute('question-index');

              if (questionSetAsset.questionIndex >= 0 && questionSetAsset.questionIndex < asset.assets.length) {
                var questionAsset = asset.assets[questionSetAsset.questionIndex].baseAsset as QuestionAsset;
                questionAsset.read = true;
              }

              if (asset.assets.length == questionIndex) {
                setAllQuestionsInQuestionSetAsRead(asset);
              }

              showQuestionInQuestionSet(sceneAssetRelationId, questionIndex);
            }
          });
        }
      });
    }

    var setQuestionIndexPosition = 'preview-set-question-index-position';
    if (!isAframeComponentRegistered(setQuestionIndexPosition)) {
      AFRAME.registerComponent(setQuestionIndexPosition, {
        schema: {
          type: 'string'
        },
        init: function () {
          var entity = this.el;
          var sceneAssetRelationId = entity.getAttribute('preview-entity-id');
          var questionIndex = entity.getAttribute('question-index');
          var assetInScene: AssetInScene = getAssetWithSceneAssetRelationId(sceneAssetRelationId);
          var questionSet: QuestionSetAsset = assetInScene.baseAsset as QuestionSetAsset;
          var question: QuestionAsset = null;
          var xPosition: number = -0.84;
          var yPosition: number = -1.58;
          var buttonsInLine: number = 0;

          var line = Math.floor(questionIndex / 8);

          if(assetInScene.assets[questionSet.questionIndex] || (question && questionSet.confirmationPage == false && question.submitted == true)){
            question = assetInScene.assets[questionSet.questionIndex].baseAsset as QuestionAsset;
          }

          if (questionSet.submitted == true) {
            yPosition = yPosition - 0.22;
          }

          questionIndex = questionIndex - (line * 8);

          yPosition = yPosition - (line * 0.22);
          xPosition = xPosition + (questionIndex * 0.24);

          if (line == 0) {
            buttonsInLine = assetInScene.assets.length <= 8 ? assetInScene.assets.length : 8;
          } else {
            buttonsInLine = assetInScene.assets.length - 8;
          }

          xPosition = xPosition + (0.94 - (buttonsInLine * 0.1175));

          entity.setAttribute('position', xPosition.toString() + ' ' + yPosition.toString() + ' 0.01');
        },
      });
    }

    var responseObjectAction = 'preview-init-event-response-object';
    if (!isAframeComponentRegistered(responseObjectAction)) {
      AFRAME.registerComponent(responseObjectAction, {
        update: function () {
          var entity = this.el;

          this.ResponseObjectEventHandler = function (evt) {
            var entityId = evt.target.getAttribute('preview-entity-id');
            var baseEntity = document.querySelector('#preview-entity-' + entityId);
            var responseId = evt.target.getAttribute('response-id');
            var type = evt.target.getAttribute('response-object-action');
            var entityObjectId = 'preview-entity-' + entityId + '-response-' + responseId;
            var asset = getAssetWithSceneAssetRelationId(entityId);
            var questionAsset = asset.baseAsset as QuestionAsset;
            var typeId = 0;
            var responseObject = null;

            if(!isEntityVisible(baseEntity))
              return;

            if (type != 'LinkedScene') {
              typeId = getAssetTypeId(type);
              responseObject = questionAsset.responses[responseId].assets.find(a => a.toBeRemoved !== true && a.baseAsset.assetTypeId === typeId);
            }

            if (type != '') {
              closeResponseObjects(entityId);

              if (type == 'Image' || type == 'Video' || type == 'Audio') {
                var entityObject = document.querySelector('#' + entityObjectId + '-' + type);
                var closeEntityObject = entityObject.parentNode.querySelector("[preview-entity-id$='" + entityId + "'][response-object][preview-close-response-object]");
                var audioControlsEntityObject = entityObject.parentNode.querySelector("[preview-entity-id$='" + entityId + "'][response-object][audio-controls-response-object]");
                if (entityObject) {
                  var isVisible = entityObject.getAttribute('isVisible');
                  var src = document.querySelector(entityObject.getAttribute('src'));
                  if (!isVisible) {
                    entityObject.setAttribute('isVisible', true);
                    entityObject.setAttribute('scale', responseObject.sceneAssetRelation.scale);
                    entityObject.setAttribute('position', responseObject.sceneAssetRelation.position);

                    if (type !== 'Audio') {
                      let xPos: number = Number(responseObject.sceneAssetRelation.xPos);
                      let yPos: number = Number(responseObject.sceneAssetRelation.yPos);
                      let xScale: number = Number(responseObject.sceneAssetRelation.xScale);
                      let yScale: number = Number(responseObject.sceneAssetRelation.yScale);
                      let closeXPos: number = xPos;
                      let closeYPos: number = yPos;
                      closeXPos = closeXPos + (xScale / 2) - 0.075;
                      closeYPos = closeYPos + (yScale / 2) + 0.075;
                      closeEntityObject.setAttribute('position', `${closeXPos.toFixed(3)} ${closeYPos.toFixed(3)} 0.55`);
                      closeEntityObject.setAttribute('scale', '0.15 0.15 0.1');
                    } else if (type == 'Audio') {
                      audioControlsEntityObject.setAttribute('scale', responseObject.sceneAssetRelation.scale);
                      audioControlsEntityObject.setAttribute('position', responseObject.sceneAssetRelation.position);
                      let playStopButton = audioControlsEntityObject.querySelector('[play-pause-response-object]');
                      if (playStopButton) playStopButton.setAttribute('src', '#pause-icon');
                    }

                    if (src && (type == 'Video' || type == 'Audio')) src.play();
                  }
                }
              } else {
                var linkedSceneId = entity.getAttribute('linked-scene-id');
                showLinkedScene(linkedSceneId);
              }
            }
          }

          entity.addEventListener('click', this.ResponseObjectEventHandler);
        },
        remove: function () {
          var entity = this.el;
          entity.removeEventListener('click', this.ResponseObjectEventHandler);
        }
      });
    }

    var closeResponseObjectAction = 'preview-close-response-object';
    if (!isAframeComponentRegistered(closeResponseObjectAction)) {
      AFRAME.registerComponent(closeResponseObjectAction, {
        init: function () {
          let entity = this.el;
          this.CloseResponseObjectEventHandler = function (evt) {
            let entityId = evt.target.getAttribute('preview-entity-id');
            closeResponseObjects(entityId);
          }
          entity.addEventListener('click', this.CloseResponseObjectEventHandler);
        },
        remove: function () {
          let entity = this.el;
          entity.removeEventListener('click', this.CloseResponseObjectEventHandler);
        }
      });
    }

    var playPauseResponseObjectAction = 'play-pause-response-object';
    if (!isAframeComponentRegistered(playPauseResponseObjectAction)) {
      AFRAME.registerComponent(playPauseResponseObjectAction, {
        init: function () {
          let entity = this.el;
          this.PlayPauseResponseObjectEventHandler = function (evt) {
            let src = evt.target.getAttribute('src');
            let responseObjectSrc = document.querySelector(evt.target.getAttribute('response-object-src'));
            if (src == '#pause-icon') {
              evt.target.setAttribute('src', '#play-icon');
              responseObjectSrc.pause();
            } else {
              evt.target.setAttribute('src', '#pause-icon');
              responseObjectSrc.play();
            }
          }
          entity.addEventListener('click', this.PlayPauseResponseObjectEventHandler);
        },
        remove: function () {
          let entity = this.el;
          entity.removeEventListener('click', this.PlayPauseResponseObjectEventHandler);
        }
      });
    }

    function closeResponseObjects(entityId) {
      let entityObjects = document.querySelectorAll("[preview-entity-id$='" + entityId + "'][response-object]");

      entityObjects.forEach(entityObject => {
        let src = document.querySelector(entityObject.getAttribute('src'));
        entityObject.removeAttribute('isVisible');
        entityObject.setAttribute('scale', '0 0 0');
        if (src && (entityObject.tagName == 'A-VIDEO' || entityObject.tagName == 'A-SOUND')) {
          let mediaElement: any = src as any;
          authorService.stopMedia(mediaElement);
        }
      });
    }

    function doesVideoTriggerBackgroundVideo(event) {
      return event == 'Play Background Video' || event == 'Stop Background Video';
    }

    function isEntityVisible(baseAssetEntity) {
      let scale = baseAssetEntity.getAttribute('scale');
      if (baseAssetEntity.getAttribute('visible') == true &&
        scale.x > 0.0001 && scale.y > 0.0001 && scale.z > 0.0001) {
        return true;
      }
    }

    function setUpAssetEvent(sceneAssetRelationId, assetEvent, eventIndex, entity) {
      var eventType = getVrEventType(assetEvent.eventTypeId);
      var useEntityOverAsset = checkIsMediaEvent(eventType) ? false : true;
      entity.setAttribute('preview-asset-event__' + eventIndex,
        {
          'linkedAssetId': assetEvent.linkedContentId,
          'triggerId': assetEvent.eventTriggerId,
          'eventTypeId': assetEvent.eventTypeId,
          'usesEntityOverAsset': useEntityOverAsset,
          'sceneAssetRelationId': sceneAssetRelationId
        });

    }

    function setUpAssetOutcomeAction(asset, outcomeActionIndex, entity) {
      var outcomeActionType = getOutcomeActionType(asset.outcomeActions[outcomeActionIndex].outcomeActionTypeId);
      var useEntityOverAsset = checkIsMediaOutcomeAction(outcomeActionType) ? false : true;

      entity.setAttribute('preview-asset-outcome-action__' + outcomeActionIndex,
        {
          'outcomeId': asset.outcomeActions[outcomeActionIndex].outcomeId,
          'outcomeActionTypeId': asset.outcomeActions[outcomeActionIndex].outcomeActionTypeId,
          'usesEntityOverAsset': useEntityOverAsset,
          'sceneAssetRelationId': asset.sceneAssetRelation.sceneAssetRelationId
        });
    }

    function triggerEvent(event, eventHandlerDto) {
      switch (event) {
        case 'Show Object': {

          showObject(eventHandlerDto.linkedEntity);
          break;
        }
        case 'Hide Object': {
          hideObject(eventHandlerDto.linkedEntity);
          break;
        }
        case 'Toggle Visibility': {
          toggleVisibility(eventHandlerDto.linkedEntity);
          break;
        }
        case 'Play Media': {
          if(eventHandlerDto.linkedEntity.getAttribute('preview-entity-id') && eventHandlerDto.linkedEntity.getAttribute('preview-entity-id') > 0){
            var entityId = eventHandlerDto.linkedEntity.getAttribute('preview-entity-id');
            var assetInScene = getAssetWithSceneAssetRelationId(entityId);
            var assetType = getAssetType(assetInScene);
            var baseEntity = document.querySelector('#preview-entity-'+entityId);
            if(baseEntity && assetType == 'Video'){
              if(!isEntityVisible(baseEntity)){
                break;
              }
            }
          }
          playMedia(eventHandlerDto.linkedEntity);
          break;
        }
        case 'Stop Media': {
          pauseMedia(eventHandlerDto.linkedEntity);
          break;
        }
        case 'Toggle Media': {
          if(eventHandlerDto.linkedEntity.getAttribute('preview-entity-id') && eventHandlerDto.linkedEntity.getAttribute('preview-entity-id') > 0){
            var entityId = eventHandlerDto.linkedEntity.getAttribute('preview-entity-id');
            var assetInScene = getAssetWithSceneAssetRelationId(entityId);
            var assetType = getAssetType(assetInScene);
            var baseEntity = document.querySelector('#preview-entity-'+entityId);
            if(baseEntity && assetType == 'Video'){
              if(!isEntityVisible(baseEntity)){
                break;
              }
            }
          }
          toggleMedia(eventHandlerDto.linkedEntity);
          break;
        }
        case 'Play Background Video': {
          eventHandlerDto.linkedEntity = document.querySelector('#preview-pano-' + getPreviewCurrentScene().sceneId);
          var videoBackground = eventHandlerDto.linkedEntity as HTMLVideoElement;
          if (videoBackground.paused) {
            videoBackground.currentTime = videoBackground.currentTime + 0.1;
          }
          playMedia(eventHandlerDto.linkedEntity);
          break;
        }
        case 'Stop Background Video': {
          eventHandlerDto.linkedEntity = document.querySelector('#preview-pano-' + getPreviewCurrentScene().sceneId);
          pauseMedia(eventHandlerDto.linkedEntity);
          break;
        }
        case 'Link Scene': {
          showLinkedScene(eventHandlerDto.linkedSceneId);
          break;
        }
      }
    }

    function triggerRule(rule) {
      var ruleType = getQuestionRuleType(rule.questionRuleTypeId);
      switch (ruleType) {
        case 'Display': {
          //var parentAssetInScene = getParentAssetInScene(rule.sceneAssetRelationId);
          //var baseEntity = document.querySelector('#preview-entity-' + parentAssetInScene.sceneAssetRelation.sceneAssetRelationId);
          var linkedEntity = document.querySelector('#preview-entity-' + rule.linkedSceneAssetRelationId);
          var linkedAssetInScene = getAssetWithSceneAssetRelationId(rule.linkedSceneAssetRelationId);
          var linkedAssetType = getAssetType(linkedAssetInScene);
          switch (linkedAssetType) {
            case 'QuestionSet': {
              showQuestionInQuestionSet(rule.linkedSceneAssetRelationId, rule.linkedQuestionIndex);
              break;
            }
          }
          //setLinkedEntityVisibility(baseEntity, false);
          setLinkedEntityVisibility(linkedEntity, true);
          break;
        }
        case 'Restart Question': {
          clearSelectedResponses(rule.sceneAssetRelationId);
          break;
        }
      }
    }

    function showObject(linkedEntity) {
      if (linkedEntity) {
        setLinkedEntityVisibility(linkedEntity, true);
        // linkedEntity.setAttribute('visible', true);
      }
    }

    function hideObject(linkedEntity) {
      if (linkedEntity) {
        setLinkedEntityVisibility(linkedEntity, false);

        // linkedEntity.setAttribute('visible', false);
      }
    }

    function toggleVisibility(linkedEntity) {
      if (linkedEntity) {
        if (linkedEntity.getAttribute('visible') == false) {
          showObject(linkedEntity);
        } else {
          hideObject(linkedEntity);
        }
      }
    }

    function setLinkedEntityVisibility(linkedEntity, isVisible) {
      if (linkedEntity) {
        linkedEntity.setAttribute('visible', isVisible);
        let textGeometry = linkedEntity.querySelector('[text-geometry]');
        if(textGeometry){
          textGeometry.setAttribute('visible', isVisible);
        }

        // var linkedEntityChildren = linkedEntity.children;
        // for (var i = 0; i < linkedEntityChildren.length; i++) {
        //   setLinkedEntityVisibility(linkedEntityChildren[i], isVisible);
        // }
      }
    }


    function playMedia(mediaElement) {
      mediaElement.play();
    }

    function toggleMedia(linkedAsset) {
      console.log(linkedAsset);
      if (linkedAsset) {
        if (linkedAsset.paused) {
          linkedAsset.play();
        } else {
          linkedAsset.pause();
        }
      }
    }

    function pauseMedia(linkedAsset) {
      linkedAsset.pause();
    }

    function getEntityEventHandlerDto(entity, linkedAssetId, trigger, usesEntityOverAsset, sceneAssetRelationId) {
      if(linkedAssetId == 0)
        linkedAssetId = sceneAssetRelationId;
        
      var eventHandlerDto = {
        'entityOrAsset': entity,
        'linkedEntity': (usesEntityOverAsset == true ? document.querySelector('#preview-entity-' + linkedAssetId) : document.querySelector('#preview-asset-' + linkedAssetId)),
        'question': null,
        'questionSet': null,
        'passOrFail': null,
        'linkedSceneId': null,
        'baseEntity': document.querySelector('#preview-entity-' + sceneAssetRelationId)
      };

      if (isQuestionTrigger(trigger)) {
        eventHandlerDto.passOrFail = trigger;
        eventHandlerDto.question = document.querySelector('#preview-entity-' + eventHandlerDto.entityOrAsset.getAttribute('preview-entity-id')); // question if question asset type
      }

      if (isQuestionSetTrigger(trigger)) {
        eventHandlerDto.passOrFail = trigger;
        eventHandlerDto.questionSet = document.querySelector('#preview-entity-' + eventHandlerDto.entityOrAsset.getAttribute('preview-entity-id'));  // question set if question asset type
      }

      // if trigger is play, ended or pause, use the entity's asset src rather than the entity;
      if (checkIsMediaTrigger(trigger)) {
        eventHandlerDto.entityOrAsset = document.querySelector('#preview-asset-' + eventHandlerDto.entityOrAsset.getAttribute('preview-entity-id'));
      }

      return eventHandlerDto;
    }

    function getEntityOutcomeActionHandlerDto(entity, outcomeActionType, usesEntityOverAsset, sceneAssetRelationId) {
      var eventHandlerDto = {
        'entityOrAsset': entity,
        'question': null,
        'questionSet': null,
        'passOrFail': null,
        'baseEntity': document.querySelector('#preview-entity-' + sceneAssetRelationId)
      };

      if (isQuestionOutcomeAction(outcomeActionType)) {
        eventHandlerDto.passOrFail = outcomeActionType;
        eventHandlerDto.question = document.querySelector('#preview-entity-' + eventHandlerDto.entityOrAsset.getAttribute('preview-entity-id')); // question if question asset type
      }

      if (isQuestionSetOutcomeAction(outcomeActionType)) {
        eventHandlerDto.passOrFail = outcomeActionType;
        eventHandlerDto.questionSet = document.querySelector('#preview-entity-' + eventHandlerDto.entityOrAsset.getAttribute('preview-entity-id')); // question set if question asset type
      }

      // if trigger is play, ended or pause, use the entity's asset src rather than the entity;
      if (checkIsMediaOutcomeAction(outcomeActionType)) {
        eventHandlerDto.entityOrAsset = document.querySelector('#preview-asset-' + eventHandlerDto.entityOrAsset.getAttribute('preview-entity-id'));
      }

      return eventHandlerDto;
    }

    // if question, return the 'submit' button on question asset, else return VR entity.
    function getEntityForEventListener(sceneAssetRelationId) {
      if (document.querySelector('#preview-submit-button-' + sceneAssetRelationId)) {
        return document.querySelector('#preview-submit-button-' + sceneAssetRelationId);
      }
      else if (document.querySelector('#preview-entity-' + sceneAssetRelationId)) {
        return document.querySelector('#preview-entity-' + sceneAssetRelationId)
      }
    }

    function isQuestionTrigger(trigger) {
      return (trigger == 'correct' || trigger == 'incorrect');
    }

    function isQuestionSetTrigger(trigger) {
      return (trigger == 'pass' || trigger == 'fail');
    }

    function checkIsMediaTrigger(trigger) {
      return (trigger == 'ended') || (trigger == 'pause') || (trigger == 'play') ? true : false;
    }

    function checkIsMediaEvent(event) {
      return (event == 'Play Media') || (event == 'Stop Media') || (event == 'Toggle Media') ? true : false;
    }

    function isQuestionOutcomeAction(outcomeActionType) {
      return (outcomeActionType == 'Correct Answer' || outcomeActionType == 'Incorrect Answer');
    }

    function isQuestionSetOutcomeAction(outcomeActionType) {
      return (outcomeActionType == 'Passed' || outcomeActionType == 'Failed');
    }

    function checkIsMediaOutcomeAction(outcomeAction) {
      return (outcomeAction == 'Pressed Play') || (outcomeAction == 'Watched') || (outcomeAction == 'Listened');
    }

    function shouldQuestionEventTrigger(selectedResponse, passOrFail) {
      var isSelectedResponseCorrect = selectedResponse.getAttribute('preview-iscorrect');
      return ((isSelectedResponseCorrect == 'true' && passOrFail == 'correct') || (isSelectedResponseCorrect == 'false' && passOrFail == 'incorrect')
        || (isSelectedResponseCorrect == 'true' && passOrFail == 'Correct Answer') || (isSelectedResponseCorrect == 'false' && passOrFail == 'Incorrect Answer'));
    }

    function shouldQuestionSetEventTrigger(assetInScene, passOrFail) {
      var questionSet = assetInScene.baseAsset as QuestionSetAsset;
      var score = getCorrectAnsweredQuestionsInAssetInScene(assetInScene).reduce((prev, cur) => {
        var question = cur.baseAsset as QuestionAsset;
        return prev + question.score
      }, 0);
      return ((score >= questionSet.minScoreToPass && passOrFail == 'pass') || (score < questionSet.minScoreToPass && passOrFail == 'fail')
        || (score >= questionSet.minScoreToPass && passOrFail == 'Passed') || (score < questionSet.minScoreToPass && passOrFail == 'Failed'));
    }

    function checkIsToTriggerRule(rule, sceneAssetRelationId, responseSelected, isSelection = false) {
      var isToTriggerRule = true;
      var ruleType = getQuestionRuleType(rule.questionRuleTypeId);
      var responseToCompare = rule.questionResponseIndex;

      if (responseToCompare >= 0) {
        if (responseToCompare != responseSelected) {
          isToTriggerRule = false;
        }
      }

      if (ruleType == 'Display' && isSelection == false) {
        isToTriggerRule = false;
      } else if (ruleType == 'Display' && isSelection == true) {
        var linkedAssetInScene = getAssetWithSceneAssetRelationId(rule.linkedSceneAssetRelationId);
        if (!linkedAssetInScene) {
          isToTriggerRule = false;
        }
      } else if (ruleType != 'Display' && isSelection == true) {
        isToTriggerRule = false;
      }

      return isToTriggerRule;
    }

    function showQuestionInQuestionSet(sceneAssetRelationId, questionIndex) {
      var assetInScene = getAssetWithSceneAssetRelationId(sceneAssetRelationId);
      var questionSet = assetInScene.baseAsset as QuestionSetAsset;
      var entity = document.querySelector('#preview-entity-' + sceneAssetRelationId);
      questionSet.questionIndex = questionIndex;
      setLinkedEntityVisibility(entity, true);
    }

    function getAllQuestionsSubmittedInAsset(assetInScene) {
      return assetInScene.assets.filter(a => {
        var questionInAsset = a.baseAsset as QuestionAsset;
        return (questionInAsset.submitted == true);
      });
    }

    function showLinkedScene(linkedSceneId) {
      if (checkSceneExists(linkedSceneId)) {
        var sky = document.querySelector('#preview-sky');
        var currentSceneAssets = document.querySelectorAll('[current-scene*="true"]');
        var oldSceneBackground;

        stopAllMedia();
        triggerLeftSceneOutcomeActions(getPreviewCurrentScene());

        if (sky) {
          sky.emit('fadeout');
          oldSceneBackground = sky;
        }
        currentSceneAssets.forEach((element: any) => {
          element.emit('hide');
        });

        setTimeout(function () {
          setCurrentScene(linkedSceneId, oldSceneBackground);
          triggerEnteredSceneOutcomeActions(getPreviewCurrentScene());
          moveCameraTo(0, Number(getPreviewCurrentScene().yRot));
        }, 500);
      }
    }

    function setCurrentScene(sceneId, oldSceneBackground) {
      setPreviewSceneIndex(sceneId);
      var currentScene = getPreviewCurrentScene();
      var parent = oldSceneBackground.parentNode;
      if (parent) {
        var sky = document.querySelector('#preview-sky');
        if (currentScene.sceneBackgroundFileType == "Image") {
          var src = "#preview-pano-" + currentScene.sceneId;
          var animation_fadeout = "property: components.material.material.color; type: color; from: #FFF; to: #000; dur: 300; startEvents: fadeout";
          var animation_fadein = "property: components.material.material.color; type: color; from: #000; to: #FFF; dur: 300; startEvents: fadein";
          setAttributes(sky, {
            "material": { "color": "#ffffff", "src": src },
            "animation__fadeout": animation_fadeout, "animation__fadein": animation_fadein
          });
          sky.emit('fadein');
        }

        if (currentScene.sceneBackgroundFileType == "") {
          var sceneBackgroundColor = currentScene.sceneBackgroundColour;
          var animation_fadeout = "property: components.material.material.color; type: color; from:" + sceneBackgroundColor + "; to: #000; dur: 300; startEvents: fadeout";
          var animation_fadein = "property: components.material.material.color; type: color; from: #000; to: " + sceneBackgroundColor + "; dur: 300; startEvents: fadein"
          setAttributes(sky, {
            "material": { "color": "#ffffff", "src": "" },
            "animation__fadeout": animation_fadeout, "animation__fadein": animation_fadein
          });
          sky.emit('fadein');
        }

        if (currentScene.sceneBackgroundFileType == "Video") {
          var src = "#preview-pano-" + currentScene.sceneId;
          var animation_fadeout = "property: components.material.material.color; type: color; from: #FFF; to: #000; dur: 300; startEvents: fadeout";
          var animation_fadein = "property: components.material.material.color; type: color; from: #000; to: #FFF; dur: 300; startEvents: fadein";
          var backgroundVideo: any = document.querySelector("#preview-pano-" + currentScene.sceneId);

          setAttributes(sky, {
            "material": { "color": "#ffffff", "src": src },
            "preview-init-video-events": "", "animation__fadeout": animation_fadeout, "animation__fadein": animation_fadein
          });

          if (currentScene.autoplay === true) {
            playMedia(backgroundVideo);
          }
        }
      }

    }

    function setAttributes(el, attrs) {
      for (var key in attrs) {
        el.setAttribute(key, attrs[key]);
      }
    }

    function stopAllMedia() {
      var media = document.querySelectorAll('video, audio');
      media.forEach((mediaElement: any) => {
        mediaElement.pause();
        mediaElement.currentTime = 0;
      });
    }

    function triggerEnteredSceneOutcomeActions(scene) {
      scene.outcomeActions.forEach(outcomeAction => {
        var outcomeActionType = getOutcomeActionType(outcomeAction.outcomeActionTypeId);
        if (outcomeActionType == 'Entered Scene') {
          achieveOutcome(outcomeAction.outcomeId);
        }
      });
    }

    function triggerLeftSceneOutcomeActions(scene) {
      scene.outcomeActions.forEach(outcomeAction => {
        var outcomeActionType = getOutcomeActionType(outcomeAction.outcomeActionTypeId);
        if (outcomeActionType == 'Left Scene') {
          achieveOutcome(outcomeAction.outcomeId);
        }
      });
    }

    function getOutcomeActionTrigger(outcomeActionType) {
      var trigger = 'click';
      switch (outcomeActionType) {
        case 'Pressed Play':
          trigger = 'play';
          break;
        case 'Watched':
        case 'Listened':
          trigger = 'ended';
          break;
      }

      return trigger;
    }

    function cloneElementById(elId: string, newElId: string) {
      var el = document.querySelector('#' + elId);
      var cloneEl: any = document.querySelector('#' + newElId);
      if (!cloneEl) {
        cloneEl = el.cloneNode(true);
        cloneEl.setAttribute('id', newElId);
        el.parentNode.appendChild(cloneEl);
      }

      return cloneEl;
    }

    function isAframeComponentRegistered(componentName) {
      return AFRAME.components[componentName] != null;
    }

    // ------ SERVICE FUNCTIONS ------
    function getAssetWithSceneAssetRelationId(sceneAssetRelationId) {
      return authorService.getAssetWithSceneAssetRelationId(sceneAssetRelationId);
    }

    function getParentAssetInScene(sceneAssetRelationId) {
      return authorService.getParentAssetInScene(sceneAssetRelationId);
    }

    function clearSelectedResponses(entityId) {
      authorService.clearSelectedResponses(entityId);
    }

    function getPreviewCurrentScene() {
      return previewService.getCurrentScene();
    }

    function checkSceneExists(sceneId) {
      return previewService.checkScenes(sceneId);
    }

    function setPreviewSceneIndex(sceneId) {
      previewService.setSceneIndex(sceneId);
    }

    function getAssetType(assetInScene) {
      return assetTypeService.getType(assetInScene.baseAsset.assetTypeId);
    }

    function getAssetTypeId(type) {
      return assetTypeService.getId(type);
    }

    function setAllQuestionsInQuestionSetAsRead(assetInScene) {
      authorService.setAllQuestionsInQuestionSetAsRead(assetInScene);
    }

    function getAssetInSceneIndex(sceneAssetRelationId) {
      return authorService.getAssetInSceneIndex(sceneAssetRelationId);
    }

    function getVrEventType(typeId) {
      return VrEventTypeService.getType(typeId);
    }

    function getVrEventTrigger(triggerId) {
      return VrEventTriggerService.getTrigger(triggerId);
    }

    function getOutcomeActionType(typeId) {
      return outcomeActionTypeService.getType(typeId);
    }

    function getQuestionRuleType(typeId) {
      return questionRuleTypeService.getType(typeId);
    }

    function getCorrectAnsweredQuestionsInAssetInScene(assetInScene) {
      return authorService.getCorrectAnsweredQuestionsInAssetInScene(assetInScene)
    }

    function achieveOutcome(outcomeId) {
      authorService.achieveOutcome(outcomeId);
    }

    function moveCameraTo(xRot, yRot) {
      authorService.moveCameraTo(xRot, yRot, 'preview-scene');
    }

    function getResponseCheckboxColour(sceneAssetRelationId) {
      return authorService.getResponseCheckboxColour(sceneAssetRelationId);
    }

    function getResponseInnerCircleColour(sceneAssetRelationId) {
      return authorService.getResponseInnerCircleColour(sceneAssetRelationId);
    }
    // ------ END SERVICE FUNCTIONS ------
  }

  formatRotation(rotation) {
    if (rotation === undefined || rotation == "null null null") {
      return "0 0 0";
    }
    else {
      return rotation;
    }
  }

  getAssetType(assetInScene) {
    var assetTypeId = assetInScene.baseAsset.assetTypeId;
    if (this.authorService.getIsAssetInAsset(assetInScene.sceneAssetRelation.sceneAssetRelationId)) {
      var parentAssetInScene = this.authorService.getParentAssetInScene(assetInScene.sceneAssetRelation.sceneAssetRelationId);
      assetTypeId = parentAssetInScene.baseAsset.assetTypeId;
    }
    return this.assetTypeService.getType(assetTypeId);
  }

  getResponseButtonType(assetInScene, responseIndex, index) {
    var questionAsset = assetInScene.baseAsset as QuestionAsset;
    var response = this.getQuestionAssetResponses(questionAsset)[responseIndex];
    var responseButtons = [];
    if (response.hasImage == true) {
      responseButtons.push('Image');
    }
    if (response.hasVideo == true) {
      responseButtons.push('Video');
    }
    if (response.hasAudio == true) {
      responseButtons.push('Audio');
    }
    if (response.hasLinkedScene == true) {
      responseButtons.push('LinkedScene');
    }

    if (index <= responseButtons.length) {
      return responseButtons[index - 1];
    } else {
      return '';
    }
  }

  getQuestionAssetResponses(questionAsset) {
    return questionAsset.responses
      .filter(r => r.toBeRemoved !== true)
      .sort((a, b) => a.questionResponseIndex > b.questionResponseIndex ? 1 : -1);
  }

  getResponseAsset(assetInScene, responseIndex, type) {
    let questionAsset = assetInScene.baseAsset as QuestionAsset;
    let response = this.getQuestionAssetResponses(questionAsset)[responseIndex];

    if (type == '') return;

    let assetTypeId = this.assetTypeService.getId(type);

    return response.assets.find(a => a.toBeRemoved === false && a.baseAsset.assetTypeId === assetTypeId);
  }

  isQuestionResponseSelected(sceneAssetRelationId) {
    var submitButton = document.querySelector('#preview-submit-button-' + sceneAssetRelationId.toString());
    if (submitButton) {
      var read = submitButton.getAttribute('read');
      if (read) {
        var responseId = submitButton.getAttribute('selected-response');
        if (responseId && +responseId >= 0) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    } else {
      return false;
    }
  }
}
